import React, { Component, createRef } from 'react';
import { Button, Typography, Card, TextField } from '@material-ui/core';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { getParsedLocations } from '../../../Services/location.service';
import LocationsPicker from '../../../LocationsPicker';
import moment from 'moment';
import axios from 'axios';
import { isEmpty, isNull } from 'lodash';
import {
    adjustForOvernightShift,
    overlaps,
    isTransfer,
    isBreak
} from './addTransferJob.service';
import { currentHttpOptions } from '../../../../../common/utilities/utilitiesFunctions';
import CustomToolTip from '../../../../../common/components/UI/ToolTip/ToolTip';
import { ShiftSegmentType, UKGShiftSegmentTypeName,  } from '../../../../Enums';
import DateFormatService from '../../../../../WorkplanManager/services/DateFormatService';
import { UkgDateFormat } from '../../../../../WorkplanManager/Enums';


class AddTransferJob extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = createRef();
        this.state = {
            cardHidden: true,
            currentTree: '',
            visible: false,
            selectedJob: {},
            startTime: null,
            endTime: null,
            shiftSegments: [],
            selectJobError: false,
            showWarningQualification: false,
            startTimeError: false,
            endTimeError: false,
            workplanLocations: [],
            locationNodes: []
        }
    }

    componentDidMount = async () => {
        const { shift, handleAddTransfert } = this.props;
        const { shiftSegments } = this.state;
        let locations;

        locations = await getParsedLocations(moment.utc().format('YYYY-MM-DD'))
        shift.segments.forEach(segment => {
            shiftSegments.push(segment);
        });
        handleAddTransfert(shiftSegments);
        this.setState({
            currentTree: locations.data,
            locationNodes: locations,
            shiftSegments
        })
    }

    handleClose = () => {
        const { cardHidden } = this.state;

        this.setState({
            cardHidden: !cardHidden,
            startTime: null,
            endTime: null
        });
    }

    handleSetStartTime = (e) => {
        const { shift } = this.props;
        const { endTime } = this.state;

        const selectedStartTime = moment(e.target.value, 'HH:mm');
        const selectedEndTime = moment(endTime, 'HH:mm');
        const shiftStartTime = moment(moment(shift.startDateTime).format('HH:mm'), 'HH:mm');
        const shiftEndTime = moment(moment(shift.endDateTime).format('HH:mm'), 'HH:mm');

        adjustForOvernightShift(shiftStartTime, shiftEndTime);
        adjustForOvernightShift(shiftStartTime, selectedStartTime);
        adjustForOvernightShift(shiftStartTime, selectedEndTime);

        const isStartBetweenShiftTime = moment(selectedStartTime).isBetween(shiftStartTime, shiftEndTime, 'minute', '[]');
        const isEndBetweenShiftTime = moment(selectedEndTime).isBetween(shiftStartTime, shiftEndTime, 'minute', '[]');
        const startTimeError = !isStartBetweenShiftTime || !selectedEndTime.isSameOrAfter(selectedStartTime);
        const endTimeError = !isEndBetweenShiftTime || !selectedStartTime.isSameOrBefore(selectedEndTime);
        this.setState({ startTime: e.target.value, startTimeError: startTimeError, endTimeError: endTimeError });
    }

    handleSetEndTime = (e) => {
        const { shift } = this.props;
        const { startTime } = this.state;

        const selectedStartTime = moment(startTime, 'HH:mm');
        const selectedEndTime = moment(e.target.value, 'HH:mm');
        const shiftStartTime = moment(moment(shift.startDateTime).format('HH:mm'), 'HH:mm');
        const shiftEndTime = moment(moment(shift.endDateTime).format('HH:mm'), 'HH:mm');

        adjustForOvernightShift(shiftStartTime, shiftEndTime);
        adjustForOvernightShift(shiftStartTime, selectedStartTime);
        adjustForOvernightShift(shiftStartTime, selectedEndTime);

        const isStartBetweenShiftTime = moment(selectedStartTime).isBetween(shiftStartTime, shiftEndTime, 'minute', '[]');
        const isEndBetweenShiftTime = moment(selectedEndTime).isBetween(shiftStartTime, shiftEndTime, 'minute', '[]');
        const startTimeError = !isStartBetweenShiftTime || !selectedEndTime.isSameOrAfter(selectedStartTime);
        const endTimeError = !isEndBetweenShiftTime || !selectedStartTime.isSameOrBefore(selectedEndTime);
        this.setState({ endTime: e.target.value, startTimeError: startTimeError, endTimeError: endTimeError });
    }

    handleSelectLocation = () => {

        this.setState({ visible: true, selectJobError: false });
    }
    spinnerState = spinnerShow => {
        this.setState({
            spinnerShow
        })
    }
    handleCancelTree = () => {
        this.setState({
            visible: false,
        });
    }

    handleCancelTransfer = () => {
        const { cardHidden } = this.state;

        this.setState({ cardHidden: !cardHidden, startTime: '', endTime: '', selectedJob: {} });
    }

    handleDelete = (segment) => {
        const { shiftSegments } = this.state;
        const { shiftlineJob, handleAddTransfert } = this.props
        let shiftSegmentsList = [];

        shiftSegments.forEach((x) => {
            if (x.orderNumber === segment.orderNumber && x.segmentType.id === segment.segmentType.id) {
                shiftSegmentsList.push({
                    ...x,
                    orgNode: { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segmentType: { id: ShiftSegmentType.Regular, qualifier: UKGShiftSegmentTypeName.Regular }

                });
            }
            else {
                shiftSegmentsList.push({
                    ...x
                })
            }
        });

        handleAddTransfert(shiftSegmentsList);
        this.setState({ shiftSegments: shiftSegmentsList });
    }

    handleAddTransfer = () => {
        const { cardHidden, startTime, endTime, selectedJob, shiftSegments, startTimeError, endTimeError } = this.state;
        const { handleAddTransfert, shiftlineJob, shift } = this.props;

        if (isEmpty(selectedJob) || startTimeError === true || endTimeError === true || isNull(startTime) || isNull(endTime)) {
            if (isEmpty(selectedJob)) { this.setState({ selectJobError: true }) }
            return;
        }

        const shiftSegmentsList = [];
        const insertSegment = (startDateTime, endDateTime, orgNode, segmentSCProfiles, segmentType, newSegment = false, modify = false) => {
            if (!startDateTime.isSameOrAfter(endDateTime)) {
                shiftSegmentsList.push({
                    startDateTime: startDateTime.format('YYYY-MM-DDTHH:mm'),
                    endDateTime: endDateTime.format('YYYY-MM-DDTHH:mm'),
                    selectedJob: { id: selectedJob.nodeId, qualifier: selectedJob.orgPath },
                    orgNode,
                    transferString: segmentType.id === ShiftSegmentType.Transfer ? orgNode.qualifier : "",
                    segmentSCProfiles,
                    segmentType,
                    orderNumber: shiftSegmentsList.length + 1,
                    newSegment,
                    modify
                });
            }
        };

        const shiftStartTime = moment(moment(shift.startDateTime).format('1900-01-01THH:mm'), 'YYYY-MM-DDTHH:mm');
        const selectedStartTime = moment(moment(startTime, 'HH:mm').format('1900-01-01THH:mm'), 'YYYY-MM-DDTHH:mm');
        const selectedEndTime = moment(moment(endTime, 'HH:mm').format('1900-01-01THH:mm'), 'YYYY-MM-DDTHH:mm');
        adjustForOvernightShift(shiftStartTime, selectedStartTime);
        adjustForOvernightShift(shiftStartTime, selectedEndTime);

        const remainingTransferToAdd = {
            startTime: selectedStartTime,
            endTime: selectedEndTime
        };

        shiftSegments.forEach(segment => {
            const segmentStartTime = moment(moment(segment.startDateTime).format('1900-01-01THH:mm'), 'YYYY-MM-DDTHH:mm');
            adjustForOvernightShift(shiftStartTime, segmentStartTime);
            const segmentEndTime = moment(moment(segment.endDateTime).format('1900-01-01THH:mm'), 'YYYY-MM-DDTHH:mm');
            adjustForOvernightShift(shiftStartTime, segmentEndTime);

            if (!overlaps(remainingTransferToAdd.startTime, remainingTransferToAdd.endTime, segmentStartTime, segmentEndTime)) {
                // New transfer does not overlap segment --> keep segment
                insertSegment(
                    segmentStartTime,
                    segmentEndTime,
                    isTransfer(segment) ? { id: segment.orgNode.id, qualifier: segment.orgNode.qualifier } : { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segment.segmentSCProfiles,
                    { id: segment.segmentType.id, qualifier: segment.segmentType.qualifier }
                );
            }
            else if (isBreak(segment)) {
                // New transfer overlaps with existing break segment --> keep segment and adjust new transfer
                insertSegment(
                    segmentStartTime,
                    segmentEndTime,
                    { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segment.segmentSCProfiles,
                    { id: segment.segmentType.id, qualifier: segment.segmentType.qualifier }
                );
                remainingTransferToAdd.startTime = segmentEndTime;
            }
            else if (remainingTransferToAdd.startTime.isBetween(segmentStartTime, segmentEndTime, undefined, '[]')
                && remainingTransferToAdd.endTime.isBetween(segmentStartTime, segmentEndTime, undefined, '[]')) {
                // New transfer is completely contained in segment --> split segment
                insertSegment(
                    segmentStartTime,
                    remainingTransferToAdd.startTime,
                    isTransfer(segment) ? { id: segment.orgNode.id, qualifier: segment.orgNode.qualifier } : { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segment.segmentSCProfiles,
                    { id: segment.segmentType.id, qualifier: segment.segmentType.qualifier },
                    false,
                    true
                );
                insertSegment(
                    remainingTransferToAdd.startTime,
                    remainingTransferToAdd.endTime,
                    { id: selectedJob.nodeId, qualifier: selectedJob.orgPath },
                    segment.segmentSCProfiles,
                    { id: ShiftSegmentType.Transfer, qualifier: UKGShiftSegmentTypeName.Transfer },
                    true
                );
                insertSegment(
                    remainingTransferToAdd.endTime,
                    segmentEndTime,
                    isTransfer(segment) ? { id: segment.orgNode.id, qualifier: segment.orgNode.qualifier } : { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segment.segmentSCProfiles,
                    { id: segment.segmentType.id, qualifier: segment.segmentType.qualifier },
                    false,
                    true
                );
                remainingTransferToAdd.startTime = remainingTransferToAdd.endTime;
            }
            else if (remainingTransferToAdd.startTime.isBetween(segmentStartTime, segmentEndTime, undefined, '[]')
                && remainingTransferToAdd.endTime.isAfter(segmentEndTime)) {
                // New transfer is partially contained in the segment --> split segment and create new transfer
                insertSegment(
                    segmentStartTime,
                    remainingTransferToAdd.startTime,
                    isTransfer(segment) ? { id: segment.orgNode.id, qualifier: segment.orgNode.qualifier } : { id: shiftlineJob.value, qualifier: shiftlineJob.label },
                    segment.segmentSCProfiles,
                    { id: segment.segmentType.id, qualifier: segment.segmentType.qualifier },
                    false,
                    true
                );
                insertSegment(
                    remainingTransferToAdd.startTime,
                    segmentEndTime,
                    { id: selectedJob.nodeId, qualifier: selectedJob.orgPath },
                    segment.segmentSCProfiles,
                    { id: ShiftSegmentType.Transfer, qualifier: UKGShiftSegmentTypeName.Transfer },
                    true
                );
                remainingTransferToAdd.startTime = segmentEndTime;
            }
            // else : New transfer is larger than segment --> ignore segment
        });

        handleAddTransfert(shiftSegmentsList);
        this.setState({ shiftSegments: shiftSegmentsList, cardHidden: !cardHidden, startTime: '', endTime: '', workplanLocations: [] });
    }

    handleSubmitTree = async () => {
        const { selectedWorkplan, shiftlineId } = this.props;
        const { workplanLocations, locationNodes } = this.state;
        const locationChecked = locationNodes[workplanLocations[0]];

        const response = await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/AddTransferJobValidation',
            {
                WorkplanId: selectedWorkplan.workplanId,
                ShiftlineId: shiftlineId,
                JobNodeId: locationChecked.nodeId,
                JobQualifier: locationChecked.orgPath
            }, currentHttpOptions()).catch(
                function (error) {
                    this.setState({
                        selectedJob: locationChecked,
                        visible: false,
                        showWarningQualification: true
                    });
                }
            );
        const validationErrors = response.data.errorMessages;
        const showWarning = validationErrors ? validationErrors.length > 0 : false;
        this.setState({
            selectedJob: locationChecked,
            visible: false,
            showWarningQualification: showWarning
        });

    }

    render() {
        const { shiftlineJob, t } = this.props
        const { cardHidden, shiftSegments, startTimeError, endTimeError, showWarningQualification,
            startTime, endTime, locationNodes, workplanLocations } = this.state;

        return (
            <>
                {shiftSegments.map((x, index) => {
                    const indexSegment = index + 1;
                    const segmentStartTime = moment(x.startDateTime);
                    const segmentEndTime = moment(x.endDateTime);
                    const segmentDurationHour = moment(segmentEndTime.diff(segmentStartTime, 'hours', true));
                    const segmentDurationMinutesFull = moment(segmentEndTime.diff(segmentStartTime, 'minutes', true));
                    const segmentDurationMinutes = Math.round(segmentDurationMinutesFull % 60);
                    const segmentDurationMinutesAdjusted = segmentDurationMinutes < 10 ? `0${segmentDurationMinutes}` : segmentDurationMinutes.toString();
                    const job = x.orgNode ? x.orgNode.qualifier : shiftlineJob.label;
                    const scProfileList = [];
                    let scProfiles = "";
                    if(x.segmentSCProfiles === undefined) {
                        scProfiles = x.scProfiles;
                    } else if (x.segmentSCProfiles !== null) {
                        x.segmentSCProfiles.forEach((element) => scProfileList.push(element.qualifier));
                        scProfiles = scProfileList.join(", ");
                    }
                    var scProfilesTag = scProfiles !== "" ? (<p>{t('workPlan.shift.segments.skillAndCertificationProfiles')}<p>{scProfiles}</p></p>) : null;

                    let segmentType = '';
                    switch (x.segmentType.id) {
                        case ShiftSegmentType.Regular:
                            segmentType = t('workPlan.shift.segments.type.regular');
                            break;
                        case ShiftSegmentType.Transfer:
                            segmentType = t('workPlan.shift.segments.type.transfer');
                            break;
                        case ShiftSegmentType.Break:
                            segmentType = t('workPlan.shift.segments.type.break');
                            break;
                        default:
                            segmentType = '';
                            break;
                    }

                    return (
                        <>
                            <Typography style={{ marginTop: 6 }}>
                                <strong>
                                    {indexSegment + '.  ' + DateFormatService.formatPeriod(x.startDateTime, x.endDateTime, UkgDateFormat.TimeFormat)
                                    + " [" + segmentDurationHour + ":" + segmentDurationMinutesAdjusted + "]: " + segmentType}
                                </strong>
                            </Typography>
                            <div style={{ display: 'flex' }}>
                                <Typography>
                                    {job}
                                    {scProfilesTag}
                                </Typography>

                                <Button
                                    onClick={() => { this.handleDelete(x) }}
                                    style={{ display: x.segmentType.id === 3 ? '' : 'none' }}
                                >
                                    <FontAwesomeIcon style={{ marginLeft: 20, paddingBottom: 8 }} size="2x" icon={faTrashAlt} />
                                </Button>
                            </div>
                        </>)
                }
                )
                }
                <Button variant="outlined" hidden={!cardHidden} onClick={this.handleClose}>
                    <Typography>{"+ Add Transfer"}</Typography>
                </Button>
                <Card style={{ marginTop: 20, border: '2px ridge' }} hidden={cardHidden} >
                    <div style={{ display: 'flex' }}>
                        <strong>
                            <Typography style={{ marginLeft: 7 }}>{"Add Transfer"}</Typography>
                        </strong>
                        <CustomToolTip
                            titletext={
                                <div>
                                    <span>{`${t('workPlan.transfer.conditions')}`}</span>
                                    <ol>
                                        <li>{`${t('workPlan.transfer.jobTransfer')}`}</li>
                                        <li>{`${t('workPlan.transfer.skills')}`}</li>
                                        <li>{`${t('workPlan.transfer.certifications')}`}</li>
                                    </ol>
                                </div>
                            }
                            jsx={
                                <div style={{ marginLeft: 'auto', marginRight: 10, marginTop: 4, color: '#ffc107', display: showWarningQualification ? '' : 'none' }} >
                                    <FontAwesomeIcon size="2x" icon={faExclamationTriangle} />
                                </div>
                            }
                            placement="left"
                        />
                    </div>

                    <div style={{ display: 'flex' }}>
                        <div>
                            <Typography style={{ marginLeft: 20, marginTop: 40 }}>{"Start Time"}</Typography>
                            <TextField
                                style={{ marginLeft: 20, marginBottom: 20 }}
                                type="time"
                                id="starttime"
                                error={startTimeError}
                                onChange={this.handleSetStartTime}
                                value={startTime}
                            />
                        </div>
                        <div style={{ marginLeft: 50 }}>
                            <Typography style={{ marginLeft: 20, marginTop: 40 }}>{"End Time"}</Typography>
                            <TextField
                                style={{ marginLeft: 20, marginBottom: 20 }}
                                type="time"
                                id="endtime"
                                error={endTimeError}
                                onChange={this.handleSetEndTime}
                                value={endTime}
                            />
                            
                        </div>
                    </div>
                    {/* <Button style={{ marginTop: 20, marginLeft: 20, marginBottom: 20, borderColor: selectJobError === true ? 'red' : '' }} variant="outlined" onClick={this.handleSelectLocation}>
                        <Typography>{isEmpty(selectedJob) ? "Select Location/Job" : selectedJob.orgPath}</Typography>
                    </Button> */}
                    <div style={{ marginLeft: 20, marginRight: 20 }}>
                        <LocationsPicker
                            period={moment().format("yyyy-MM-DD")}
                            locationNodes={locationNodes}
                            selectedNodeIds={workplanLocations}
                            onConfirm={(values) => this.setState({ workplanLocations: values }, () => this.handleSubmitTree())}
                            t={t}
                            singleSelection={true}
                        />
                    </div>

                    <div style={{ textAlign: 'right', marginRight: 15 }}>
                        <Button style={{ marginTop: 10, marginBottom: 20, marginRight: 10 }} variant="outlined" onClick={this.handleAddTransfer}>
                            <Typography>{"Add"}</Typography>
                        </Button>
                        <Button style={{ marginTop: 10, marginBottom: 20 }} variant="outlined" onClick={this.handleCancelTransfer}>
                            <Typography>{"Cancel"}</Typography>
                        </Button>
                    </div>
                </Card>
            </ >
        )
    }
}

export default translate('workplanManager')(AddTransferJob);